export default "__VITE_ASSET__BEi_h5xp__"